import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SideBarComponent} from './side-bar/side-bar.component';
import {AppRoutingModule} from '../app-routing.module';
import {HeaderComponent} from './header/header.component';
import {RouterModule} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SubjectiveParamComponent} from './subjective-param/subjective-param.component';


@NgModule({
  declarations: [SideBarComponent, HeaderComponent, SubjectiveParamComponent],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
  ],
  exports: [SideBarComponent, HeaderComponent, SubjectiveParamComponent]
})
export class ComponentsModule {
}
